"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_entity_search_client_js_1 = require("@synisys/idm-entity-search-client-js");
var Observable_1 = require("rxjs/Observable");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var table_item_1 = require("../model/table-item");
var table_data_1 = require("../model/table-data");
var combineLatest_1 = require("rxjs/observable/combineLatest");
var idm_um_permission_client_js_1 = require("@synisys/idm-um-permission-client-js");
var http_1 = require("@angular/common/http");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
/**
 * Please provide this service for each component as this service keeps cached data of components
 *
 */
// tslint:disable
var TableItemDeserializerService = /** @class */ (function () {
    function TableItemDeserializerService(classifierService, entitySearchService, kbService, currentLanguageProvider, applicationPropertiesService, http) {
        this.classifierService = classifierService;
        this.entitySearchService = entitySearchService;
        this.kbService = kbService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.applicationPropertiesService = applicationPropertiesService;
        this.http = http;
        this.monthNames = [
            "Jan", "Feb", "Mar",
            "Apr", "May", "Jun", "Jul",
            "Aug", "Sep", "Oct",
            "Nov", "Dec"
        ];
        this.serviceUri$ = Observable_1.Observable.from(this.applicationPropertiesService.getProperty("entity-search-service-url"));
    }
    TableItemDeserializerService_1 = TableItemDeserializerService;
    TableItemDeserializerService.prototype.loadPortfolioItems = function (categorySystemName, columnSystemNames, columnSystemNamesInvisable, pagingOption, filterCriteria, sortingOptions, pageLimit, externalFilterValue, permissionType) {
        var _this = this;
        !columnSystemNamesInvisable && (columnSystemNamesInvisable = []);
        if (!this.currentLanguageId$) {
            this.initializeCurrentLanguage();
        }
        if (!this.categoryIdentityMetaFields$ || !this.categoryMetaFields$) {
            this.initializeCategoryMetaFields(categorySystemName, [].concat(columnSystemNames).concat(columnSystemNamesInvisable));
        }
        return Observable_1.Observable.combineLatest(this.currentLanguageId$, this.categoryMetaFields$, this.categoryIdentityMetaFields$).switchMap(function (data) {
            var languageId = data[0];
            var metaFields = data[1];
            var identityName = data[2].getSystemName();
            var portfolioData = new table_data_1.TableData();
            portfolioData.metaFields = metaFields.filter(function (metaField) { return columnSystemNames.find(function (columnSystemName) {
                return metaField.getSystemName() === columnSystemName;
            }); });
            //TODO: should be changed to return empty area when no filterCriteria is provided, send empty filter where data should be loaded by default without filtering
            return (!externalFilterValue ? _this.getEntityWithoutExternalFilter(categorySystemName, columnSystemNames, columnSystemNamesInvisable, identityName, languageId, pagingOption, sortingOptions, filterCriteria, permissionType)
                : _this.getEntitiesWithExternalFilter(categorySystemName, filterCriteria, externalFilterValue, pagingOption, sortingOptions, permissionType))
                .switchMap(function (responseEntitySearch) {
                portfolioData.totalCount = responseEntitySearch.getTotalRowCount();
                portfolioData.pageTotalCount = Math.ceil(portfolioData.totalCount / pageLimit);
                return _this.deserializeEntityByGivenKeys(categorySystemName, [].concat(columnSystemNames).concat(columnSystemNamesInvisable), responseEntitySearch.getData(), metaFields, languageId);
            }).map(function (items) {
                portfolioData.portfolioItems = items;
                return portfolioData;
            });
        });
    };
    TableItemDeserializerService.prototype.getEntityWithoutExternalFilter = function (categorySystemName, columnSystemNames, columnSystemNamesInvisable, identityName, languageId, pagingOption, sortingOptions, filterCriteria, permissionType) {
        var categoryPermissionType = (permissionType && permissionType === "EDIT") ? idm_um_permission_client_js_1.CategoryPermissionType.EDIT : idm_um_permission_client_js_1.CategoryPermissionType.VIEW;
        return this.entitySearchService.loadEntitySearchItems(categorySystemName, [].concat(columnSystemNames).concat(columnSystemNamesInvisable), [], [], identityName, languageId, pagingOption, sortingOptions, filterCriteria ? filterCriteria : new idm_de_core_frontend_1.FilterBuilder().build(), [categoryPermissionType]);
    };
    TableItemDeserializerService.prototype.getEntitiesWithExternalFilter = function (categoryName, filterCriteria, externalFilterValue, pagingOption, sorting, permissionType) {
        var _this = this;
        permissionType = !permissionType ? "VIEW" : permissionType;
        var httpParams = new http_1.HttpParams();
        var headers = new http_1.HttpHeaders({ "Content-Type": "application/json" });
        var options = { headers: headers, httpParams: httpParams };
        var data$ = this.serviceUri$
            .map(function (classifierServiceUri) {
            return TableItemDeserializerService_1.ENTITY_LOAD_URL.replaceTemplate({
                "serviceUri": classifierServiceUri
            });
        }).switchMap(function (url) {
            return _this.http.post(url, JSON.stringify({
                "category": categoryName,
                "paging": pagingOption,
                "sortFields": sorting,
                // tslint:disable-next-line:no-invalid-template-strings
                "categoryPermissionTypes": [permissionType],
                "filter": filterCriteria,
                // tslint:disable-next-line:no-invalid-template-strings
                "externalFilter": externalFilterValue
            }), options);
        });
        return data$.map(function (responseData) {
            var response = new idm_entity_search_client_js_1.ResponseData();
            response.setTotalRowCount(responseData["meta"]["totalRowCount"]);
            response.setData(responseData['data'].map(function (item) {
                return new idm_entity_search_client_js_1.EntitySearchItem(item[categoryName + "InstanceID"], null, item);
            }));
            return response;
        });
    };
    TableItemDeserializerService.prototype.initializeCategoryMetaFields = function (categorySystemName, columnSystemNames) {
        var systemNames = columnSystemNames
            .map(function (columnSystemName) {
            var isNotInnerKey = columnSystemName.indexOf('.') < 0;
            return isNotInnerKey ? columnSystemName : columnSystemName.split('.')[0];
        });
        var allMetaFields$ = this.kbService.getMetaFields(categorySystemName).shareReplay(1);
        var metaCategory$ = this.kbService.getMetaCategoryByMetaCategoryId(new idm_kb_service_client_js_1.MetaCategoryId(categorySystemName)).shareReplay(1);
        this.categoryMetaFields$ = allMetaFields$
            .map(function (metaFields) {
            var sortedMetaData = [];
            metaFields.forEach(function (metaField) {
                var index = systemNames.findIndex(function (columnName) { return columnName === metaField.getSystemName(); });
                index >= 0 && (sortedMetaData[index] = metaField);
            });
            return sortedMetaData;
        }).shareReplay(1);
        this.categoryIdentityMetaFields$ = combineLatest_1.combineLatest(allMetaFields$, metaCategory$)
            .map(function (_a) {
            var metaFields = _a[0], metaCategory = _a[1];
            return metaFields.find(function (metaField) {
                return metaCategory.getIsClassifier() ? metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.INTEGER_IDENTITY
                    : metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.INTEGER_INSTANCE;
            });
        }).shareReplay(1);
    };
    TableItemDeserializerService.prototype.initializeCurrentLanguage = function () {
        this.currentLanguageId$ = this.currentLanguageProvider.getCurrentLanguage()
            .map(function (currentLanguage) { return currentLanguage.getId(); }).shareReplay(1);
    };
    TableItemDeserializerService.prototype.deserializeEntityByGivenKeys = function (categorySystemName, fieldSystemNames, entitySearchItems, metaFields, languageId) {
        var _this = this;
        var entityCache$ = new Map();
        var deserialized$ = entitySearchItems.map(function (entitySearchItem) {
            var entityJson = entitySearchItem.entity;
            var portfolioItem = new table_item_1.TableItem();
            portfolioItem.entityInstanceId = entitySearchItem.id;
            portfolioItem.entitySearchItem = entitySearchItem;
            return Observable_1.Observable.combineLatest(fieldSystemNames.map(function (fieldSystemName) {
                var field = [];
                var isNotInnerKey = fieldSystemName.indexOf('.') < 0;
                field = isNotInnerKey ? [fieldSystemName] : fieldSystemName.split('.');
                var metaField = metaFields.find(function (metaFieldToCheck) {
                    return field[0] === metaFieldToCheck.getSystemName();
                });
                switch (metaField.getType()) {
                    case idm_kb_service_client_js_1.MetaFieldType.WORKFLOW_STATE:
                    case idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER: {
                        if (!entityCache$.get(metaField.getCompoundCategorySystemName() + "_" + field[0])) {
                            _this.addClassifiersToCache(entityCache$, field, entitySearchItems, metaField, isNotInnerKey);
                        }
                        return entityCache$.get(metaField.getCompoundCategorySystemName() + "_" + field[0]).map(function (classifiers) {
                            var classifier = classifiers.find(function (classifier) { return classifier.id === _this.getFieldValue(entityJson, field[0]); });
                            portfolioItem.valueOfColumn.set(fieldSystemName, classifier ? classifier.name : null);
                            return true;
                        });
                    }
                    case idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY: {
                        return _this.kbService.getMainEntityMetaFields(categorySystemName, metaField.getMetaFieldId().getSystemName())
                            .switchMap(function (entityFields) {
                            return _this.deserializeMainEntity(entityFields, portfolioItem, entityJson, field, fieldSystemName, entityCache$, metaField, entitySearchItems, languageId);
                        });
                    }
                    case idm_kb_service_client_js_1.MetaFieldType.DATE: {
                        var dateStr = _this.getFieldValue(entityJson, field[0]);
                        var formattedDate = _this.formatDate(dateStr ? new Date(+dateStr) : null, false);
                        portfolioItem.valueOfColumn.set(fieldSystemName, formattedDate);
                        return Observable_1.Observable.of(true);
                    }
                    case idm_kb_service_client_js_1.MetaFieldType.DATE_TIME: {
                        var dateStr = _this.getFieldValue(entityJson, field[0]);
                        var formattedDate = _this.formatDate(dateStr ? new Date(+dateStr) : null, true);
                        portfolioItem.valueOfColumn.set(fieldSystemName, formattedDate);
                        return Observable_1.Observable.of(true);
                    }
                    case idm_kb_service_client_js_1.MetaFieldType.ACCOUNTING: {
                        var accountingJson = _this.getFieldValue(entityJson, field[0]);
                        portfolioItem.valueOfColumn.set(fieldSystemName, (accountingJson && accountingJson["currencyMoney"])
                            ? accountingJson["currencyMoney"][accountingJson.rateToDefault] : null);
                        return Observable_1.Observable.of(true);
                    }
                    case idm_kb_service_client_js_1.MetaFieldType.MULTILINGUAL_STRING: {
                        var mlValue = _this.getFieldValue(entityJson, field[0]);
                        portfolioItem.valueOfColumn.set(fieldSystemName, mlValue[languageId]);
                        return Observable_1.Observable.of(true);
                    }
                    default: {
                        portfolioItem.valueOfColumn.set(fieldSystemName, _this.getFieldValue(entityJson, field[0]));
                        return Observable_1.Observable.of(true);
                    }
                }
            })).map(function () { return portfolioItem; });
        });
        return deserialized$.length ? Observable_1.Observable.combineLatest(deserialized$).take(1) : Observable_1.Observable.of([]);
    };
    TableItemDeserializerService.prototype.deserializeMainEntity = function (entityFields, portfolioItem, entityJson, field, fieldSystemName, entityCache$, metaField, entitySearchItems, languageId) {
        var _this = this;
        if (!entityFields.length || entityFields.length === 1 && entityFields[0].getType() === idm_kb_service_client_js_1.MetaFieldType.INTEGER_INSTANCE
            || (!!entityFields.find(function (entityField) { return entityField.getSystemName() === field[1] && entityField.getType() === idm_kb_service_client_js_1.MetaFieldType.INTEGER_INSTANCE; }))) {
            portfolioItem.valueOfColumn.set(fieldSystemName, this.getFieldValue(entityJson, field[0]));
            return Observable_1.Observable.of(true);
        }
        else {
            if (!entityCache$.get(metaField.getCompoundCategorySystemName())) {
                this.addMainEntitiesToCache(entityCache$, field, entitySearchItems, metaField, languageId);
            }
            return entityCache$.get(metaField.getCompoundCategorySystemName()).map(function (entities) {
                var entity = entities.find(function (entity) { return entity.id === _this.getFieldValue(entityJson, field[0]); });
                portfolioItem.valueOfColumn.set(fieldSystemName, (entity && entity.name) ? ((typeof entity.name === "string")
                    ? entity.name : entity.name[languageId]) : entity);
                return true;
            });
        }
    };
    TableItemDeserializerService.prototype.addClassifiersToCache = function (classifiersCache$, fieldName, dataItems, metaField, isNotInnerKey) {
        var _this = this;
        var ids = new Set();
        dataItems.forEach(function (jsonItem) {
            var id = _this.getFieldValue(jsonItem.entity, fieldName[0]);
            if (id) {
                ids.add(id);
            }
        });
        classifiersCache$.set(metaField.getCompoundCategorySystemName() + "_" + fieldName[0], ids.size ?
            this.handleClassifier(metaField, fieldName, isNotInnerKey, ids) : Observable_1.Observable.of([]));
    };
    TableItemDeserializerService.prototype.handleClassifier = function (metaField, fieldName, isNotInnerKey, ids) {
        var _this = this;
        if (fieldName[1] === "Full") {
            return this.classifierService.loadClassifiersByIds(metaField.getCompoundCategorySystemName(), Array.from(ids), true)
                .mergeMap(function (classifiers) {
                return Observable_1.Observable.of(classifiers.getData().map(function (classifier) {
                    return { id: classifier.getId(), name: classifier };
                }));
            }).publishReplay(1).refCount();
        }
        return this.classifierService.loadClassifiersByIds(metaField.getCompoundCategorySystemName(), Array.from(ids))
            .mergeMap(function (classifiers) {
            if (isNotInnerKey) {
                return Observable_1.Observable.combineLatest(classifiers.getData().map(function (classifier) {
                    return _this.classifierService.getEntityName(metaField.getCompoundCategorySystemName(), classifier).map(function (name) {
                        return { id: classifier.getId(), name: name };
                    });
                }));
            }
            else {
                return Observable_1.Observable.of(classifiers.getData().map(function (classifier) {
                    return { id: classifier.getId(), name: classifier.getProperty(fieldName[1]).value };
                }));
            }
        }).publishReplay(1).refCount();
    };
    TableItemDeserializerService.prototype.addMainEntitiesToCache = function (entityCache$, field, dataItems, metaField, languageId) {
        var _this = this;
        var filterBuilder = new idm_de_core_frontend_1.FilterBuilder();
        var ids = new Set();
        dataItems.forEach(function (jsonItem) {
            var id = _this.getFieldValue(jsonItem.entity, field[0]);
            if (id) {
                ids.add(id);
            }
        });
        var categorySystemName = metaField.getCompoundCategorySystemName();
        entityCache$.set(categorySystemName, ids.size ? this.kbService.getInstanceMetaField(categorySystemName)
            .mergeMap(function (instanceMetaField) {
            return filterBuilder ? _this.entitySearchService.loadEntitySearchItems(categorySystemName, [field[1]], [], [], instanceMetaField.getSystemName(), languageId, new idm_de_core_frontend_1.PagingOptions(0, 10000), null, filterBuilder.in(instanceMetaField.getSystemName(), Array.from(ids)).build(), [idm_um_permission_client_js_1.CategoryPermissionType.VIEW])
                .map(function (responseEntitySearch) {
                return responseEntitySearch.getData().map(function (items) {
                    return { id: items.id, name: items.entity[field[1]] };
                });
            })
                : Observable_1.Observable.of([]);
        }).shareReplay(1) : Observable_1.Observable.of([]));
    };
    TableItemDeserializerService.prototype.formatDate = function (date, isDateTime) {
        if (date) {
            var day = this.addZeroIfNeeded(date.getDate());
            var monthIndex = date.getMonth();
            var year = this.addZeroIfNeeded(date.getFullYear());
            var time = '';
            if (isDateTime) {
                var hours = this.addZeroIfNeeded(date.getHours());
                var minutes = this.addZeroIfNeeded(date.getMinutes());
                time = " " + hours + ":" + minutes;
            }
            return day + " " + this.monthNames[monthIndex] + " " + year + " " + time;
        }
        return null;
    };
    TableItemDeserializerService.prototype.addZeroIfNeeded = function (num) {
        return (num >= 10) ? num : ('0' + num);
    };
    TableItemDeserializerService.prototype.getFieldValue = function (jsonItem, systemName) {
        return jsonItem ? (jsonItem[systemName] || jsonItem[systemName] === 0 || jsonItem[systemName] === ""
            || jsonItem[systemName] === false) ? jsonItem[systemName] : jsonItem._propertiesMap
            ? jsonItem._propertiesMap.get(systemName)._value : null : null;
    };
    var TableItemDeserializerService_1;
    TableItemDeserializerService.ENTITY_LOAD_URL = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", "/table/entities/"], ["", "/table/entities/"])), "serviceUri");
    TableItemDeserializerService = TableItemDeserializerService_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_classifier_service_client_js_1.ClassifierService,
            idm_entity_search_client_js_1.EntitySearchService,
            idm_kb_service_client_js_1.KbService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            idm_application_properties_service_client_js_1.ApplicationPropertiesService,
            idm_authentication_client_js_1.HttpClientWrapper])
    ], TableItemDeserializerService);
    return TableItemDeserializerService;
}());
exports.TableItemDeserializerService = TableItemDeserializerService;
var templateObject_1;
//# sourceMappingURL=table-item-deserializer.service.js.map